import { AddCircle } from '@material-ui/icons';
import strings from 'common/strings';
import useUploadStore from 'store/uploads/useUploadStore';
import { UploadTarget, UploadType } from 'store/uploads/types';
import { useFileSelector, useWindowSize } from 'hooks';
import { useDraggable } from 'muuri-react';
import React, { useCallback, useState } from 'react';
import './EngageMediaPlaceholder.scss';
import { useCreateFolioDocument } from 'api';

const handleOnError = (
  event: string | Event,
  setShowErrorAlert: any,
  setErrorMessage: any
) => {
  setShowErrorAlert(false);
  setErrorMessage(strings.API_MESSAGE);
};

interface EngageMediaPlaceholderProps {
  title: string;
  folderId: string;
  vehicleId: string;
}

const EngageMediaPlaceholder: React.FC<EngageMediaPlaceholderProps> = ({
  title,
  vehicleId,
  folderId,
}) => {
  const windowSize = useWindowSize();
  const { mutate: createFolioDocument } = useCreateFolioDocument();
  // TODO add alert dialog and remove disable lint lines
  // eslint-disable-next-line
  const [showErrorAlert, setShowErrorAlert] = useState(true);
  // eslint-disable-next-line
  const [errorMessage, setErrorMessage] = useState(strings.API_MESSAGE);
  const uploadFiles = useUploadStore((uploadStore) => uploadStore.uploadFiles);
  const handleOnChange = useCallback(
    (
      event: Event,
      vehicleId: string,
      folderId: string,
      setShowErrorAlert: any,
      setErrorMessage: any
    ) => {
      const target = event.target as HTMLInputElement;
      const files = target.files ? Array.from(target.files) : [];

      if (files) {
        const onUploadSuccess = async (mediaUrl?: string) => {
          if (mediaUrl && vehicleId && folderId) {
            await createFolioDocument({
              vehicleId: vehicleId,
              folioFolderId: folderId,
              url: mediaUrl,
              displayLabel: files[0].name,
            });
          }
        };
        const onUploadError = async () => {
          setShowErrorAlert(false);
          setErrorMessage(strings.API_MESSAGE);
        };
        const onUploadCancel = () => {
          target.value = '';
        };
        const uploadTarget: UploadTarget = {
          type: UploadType.ENGAGE_MEDIA,
        };

        if (vehicleId) {
          // TODO uploading indicator
          uploadFiles(
            files,
            vehicleId,
            uploadTarget,
            onUploadSuccess,
            onUploadError,
            onUploadCancel
          );
        }
      }
    },
    [createFolioDocument, uploadFiles]
  );

  const onChange = useCallback(
    (event) =>
      handleOnChange(
        event,
        vehicleId,
        folderId,
        setShowErrorAlert,
        setErrorMessage
      ),
    [handleOnChange, vehicleId, folderId]
  );
  const onError = useCallback(
    (event) => handleOnError(event, setShowErrorAlert, setErrorMessage),
    []
  );
  const [fileSelector] = useFileSelector(onChange, onError);
  const setDraggable = useDraggable();
  const onClick = useCallback(
    (event) => {
      if (vehicleId) {
        event.stopPropagation();
        fileSelector.click();
      }
    },
    [vehicleId, fileSelector]
  );
  setDraggable(false);

  var LargeMediaPlaceholder = () => {
    return (
      <div
        className="EngageMediaPlaceholder item"
        role="none"
        onClick={onClick}
      >
        <div className="item-content">
          <div className="EngageMediaPlaceholder-content">
            <AddCircle className="EngageMediaPlaceholder-icon" />
            <span className="EngageMediaPlaceholder-title">{title}</span>
          </div>
        </div>
      </div>
    );
  };

  var SmallMediaPlaceholder = () => {
    return (
      <div
        className="EngageMediaPlaceholder-small item"
        role="none"
        onClick={onClick}
      >
        <div className="item-content">
          <div className="EngageMediaPlaceholder-content">
            <AddCircle className="EngageMediaPlaceholder-icon" />
          </div>
        </div>
      </div>
    );
  };

  return windowSize.isMobileViewport() ? (
    <SmallMediaPlaceholder />
  ) : (
    <LargeMediaPlaceholder />
  );
};

export default EngageMediaPlaceholder;
